export default __webpack_public_path__ + "static/media/gallery159_2.3cc22877.png";